import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getOrgClasses } from "../../../../service/endpoints";

export const getClassHandler = createAsyncThunk('getClassHandler', async(data) => {
    try {
        const response = await getOrgClasses(data)
        console.log(response,'class')
        return response.data
       

        } catch (error) {
            if (error.response !== undefined) {
                console.log('fail', error)
                throw error.response
            }
            else {
                console.log(error)
                throw error.response
            }
        }
})




const orgClassSlice = createSlice({
    name: 'getClasses',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(getClassHandler.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getClassHandler.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(getClassHandler.rejected, (state, action) => {
            console.log(action.state)
            state.isError = true;
            console.log(action.payload);

        })
       
    }

});



export default orgClassSlice.reducer;
